export default __webpack_public_path__ + "static/media/image1.a66b1aa7.bmp";